import * as angular from "angular";
import {TextTemplateReceiverType} from "../types/text-template-receiver.type";

export class TextTemplatesRequestsService {

  /* @ngInject */
  constructor(private TextTemplatesAPI, private $textTemplates) {
  }

  getTemplates(type: TextTemplateReceiverType, accountId?: string) {
    const api = this.TextTemplatesAPI.actions.getTemplates;
    return this.$$call(api, {receiverType: type, accountId: accountId}, {}, {});
  }

  createTemplate(data, accountId) {
    const api = this.TextTemplatesAPI.actions.createTemplate;
    return this.$$call(api, {accountId: accountId}, data, {});
  }

  editTemplate(data, id, accountId) {
    const api = this.TextTemplatesAPI.actions.editTemplate;
    return this.$$call(api, {accountId: accountId}, data, {id: id});
  }

  resetTemplate(id, accountId) {
    const api = this.TextTemplatesAPI.actions.resetTemplate;
    return this.$$call(api, {accountId: accountId}, {}, {id: id});
  }

  // ******************************
  //        Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$textTemplates().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.text-templates')
  .service('textTemplatesRequestsService', TextTemplatesRequestsService);
